import { useEffect } from 'react';
import { markTaskViewedFromHistory } from '@/utils/workbenchHistoryBadge';
import { resolveFeatureBadgeScopeId } from '@/pages/ipe/workbench/utils/showTaskCreatedDetailToast';
import { useIpeWorkspaceMode } from '@/pages/ipe/workbench/hooks/useIpeWorkspaceMode';

/**
 * 角标语义：未读 = 尚未打开对应详情；只清当前 workspaceMode 桶，避免串清。
 * 标准流程：创建 → 角标+1 → 历史记录选详情 → 进入详情 → 清角标。
 *
 * @param {string} navIdOrScope workbench navId 或 badge scopeId
 * @param {string} taskId 与 trackPendingTask 一致的任务 / batch id
 */
export default function useMarkHistoryDetailViewed(navIdOrScope, taskId) {
  const workspaceMode = useIpeWorkspaceMode();

  useEffect(() => {
    const id = String(taskId || '').trim();
    const nav = String(navIdOrScope || '').trim();
    if (!id || !nav) return;
    const scope = resolveFeatureBadgeScopeId(nav) || nav;
    markTaskViewedFromHistory(scope, id, workspaceMode);
  }, [navIdOrScope, taskId, workspaceMode]);
}
